import React, { useState } from 'react';
import TextEditBlock from '../invoice/texteditblock';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Button, IconButton, FormControl, InputLabel, Select, MenuItem, Chip, Input } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';

const styles = {
    btn: { m: 1 },
    chips: { display: 'flex', flexWrap: 'wrap' },
    chip: { m: '2px' },
    materialSelect: { minWidth: 200 },
};

export default function CpStandardPricingRow(props) {
    const { row, edit, materials, standardClasses, onClick, rowChanged, prodPreviews, cancel, save, deleteRule } =
        props;
    const { t } = useTranslation();
    const [saving, setSaving] = useState(false);

    const handleDiscountChange = (e) => {
        let value = e.target.value.toString().replace(',', '.');
        const newData = cloneDeep(row);
        if (!/^-?\d*[.]?\d{0,4}$/.test(value)) {
            return;
        } else if (!(value > 100 || value < -100)) {
            newData.discount = value;
            rowChanged(newData);
        }
    };

    const handleTypeChange = (e) => {
        const newData = cloneDeep(row);
        newData.type = e.target.value;
        // Reset materials when type changes since different types have different material options
        newData.materials = [];
        rowChanged(newData);
    };

    const handleMaterialChange = (e) => {
        const newData = cloneDeep(row);
        // e.target.value is now an array for multi-select
        newData.materials = e.target.value;
        rowChanged(newData);
    };

    const handleClassChange = (e) => {
        const newData = cloneDeep(row);
        newData.standardClass = e.target.value;
        rowChanged(newData);
    };

    return (
        <React.Fragment>
            <TableRow onClick={() => !edit && onClick(row.id)}>
                {!edit && <TableCell>{row.type}</TableCell>}
                {edit && (
                    <TableCell>
                        <FormControl>
                            <InputLabel id="prodtype-label">{t('product.type')}</InputLabel>
                            <Select
                                required
                                labelId="prodtype-label"
                                id={'prodtype'}
                                name="prodtype"
                                value={row.type}
                                onChange={(e) => handleTypeChange(e)}>
                                {Object.keys(materials).map((code) => (
                                    <MenuItem key={code} value={code}>
                                        {code}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </TableCell>
                )}
                {!edit && <TableCell>{row.materials.join(', ')}</TableCell>}
                {edit && (
                    <TableCell>
                        <FormControl sx={styles.materialSelect}>
                            <InputLabel id="material-label">{t('survey.material')}</InputLabel>
                            <Select
                                multiple
                                required
                                labelId="material-label"
                                id={'material'}
                                name="material"
                                value={row.materials || []}
                                onChange={(e) => handleMaterialChange(e)}
                                input={<Input id="select-multiple-chip" />}
                                renderValue={(selected) => (
                                    <Box sx={styles.chips}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} sx={styles.chip} />
                                        ))}
                                    </Box>
                                )}>
                                {(materials[row.type] || []).map((code) => (
                                    <MenuItem key={code} value={code}>
                                        {code}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </TableCell>
                )}
                {!edit && <TableCell>{row.standardClass > 0 ? row.standardClass : t('product.nonStandard')}</TableCell>}
                {edit && (
                    <TableCell>
                        <FormControl>
                            <InputLabel id="standardclass-label">{t('product.standardClass')}</InputLabel>
                            <Select
                                required
                                labelId="standardclass-label"
                                id={'standardclass'}
                                name="standardclass"
                                value={row.standardClass}
                                onChange={(e) => handleClassChange(e)}>
                                <MenuItem value={-1}>-Valitse-</MenuItem>
                                {standardClasses.map((code) => (
                                    <MenuItem key={code.class} value={code.class}>
                                        {code.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </TableCell>
                )}
                {!edit && <TableCell>{row.discount} %</TableCell>}
                {edit && (
                    <TableCell>
                        <TextEditBlock
                            name="discount"
                            value={row.discount}
                            number={true}
                            onChange={(e) => handleDiscountChange(e)}
                        />
                    </TableCell>
                )}
                <TableCell>{prodPreviews}</TableCell>
                {edit && (
                    <TableCell>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={styles.btn}
                            disabled={saving}
                            onClick={async () => {
                                setSaving(true);
                                await save(row.id);
                                setSaving(false);
                            }}>
                            {t('buttons.save')}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={styles.btn}
                            disabled={saving}
                            onClick={() => {
                                cancel(row.id);
                            }}>
                            {t('buttons.cancel')}
                        </Button>
                    </TableCell>
                )}
                {!edit && (
                    <TableCell>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                deleteRule(row.id);
                            }}>
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                )}
            </TableRow>
        </React.Fragment>
    );
}
